/**
 * How full a run's context is, for the composer's ring.
 *
 * .mjs so the gate can test it straight off the source tree (see sessions.mjs).
 */
import { CONTEXT_FLOOR, contextShare, windowFor } from "./usage.mjs";

export { CONTEXT_FLOOR, contextShare, windowFor };
